/*
 * Reveals the specification rows held back by the row limit. The toggle stays
 * hidden when there are no extra rows, so a short table shows no Read More.
 */
class ProductSpecs extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-specs-toggle]');
    this.toggleText = this.querySelector('[data-specs-toggle-text]');
    this.extras = Array.from(this.querySelectorAll('[data-specs-extra]'));
    if (!this.toggle || this.extras.length === 0) return;

    this.moreLabel = this.dataset.moreLabel || 'Read More';
    this.lessLabel = this.dataset.lessLabel || 'Read Less';

    this.toggle.hidden = false;
    this.toggle.addEventListener('click', this.onToggle.bind(this));
  }

  onToggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.extras.forEach((row) => {
      row.hidden = !expanded;
    });
    if (this.toggleText) {
      this.toggleText.textContent = expanded ? this.lessLabel : this.moreLabel;
    }
    this.toggle.setAttribute('aria-expanded', String(expanded));
  }
}

if (!customElements.get('product-specs')) {
  customElements.define('product-specs', ProductSpecs);
}
